/* The Irish Craft Soda Co. — Shopify theme JS
   Visual behaviors (fade-in, header scroll, stat counter, tilt, mobile menu)
   + Shopify Ajax Cart API integration. */

(function () {
  'use strict';

  const money = (cents) => '€' + (cents / 100).toFixed(2);
  const FREE_SHIP_CENTS = 3000; // €30

  async function fetchCart() {
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return await r.json();
    } catch (e) { console.warn('cart fetch failed', e); return null; }
  }

  async function addToCart(variantId, qty) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }),
    });
    if (!r.ok) throw new Error('add failed');
    return r.json();
  }

  async function changeQty(key, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    return r.json();
  }

  function renderCart(cart) {
    if (!cart) return;
    document.querySelectorAll('.cart-count').forEach((c) => {
      c.textContent = cart.item_count;
      c.classList.toggle('hidden', cart.item_count === 0);
    });

    const items = document.querySelector('.cart-items');
    if (items) {
      if (!cart.items.length) {
        items.innerHTML =
          '<p style="opacity:0.5;text-align:center;padding:2rem 0;">Your cart is empty. Time to stock up!</p>';
      } else {
        items.innerHTML = cart.items.map((i) => `
          <div class="cart-item">
            <img src="${i.image || ''}" alt="" style="width:40px;height:60px;object-fit:cover;border-radius:4px;">
            <div class="cart-item-info" style="flex:1;">
              <h4>${i.product_title}</h4>
              <p>${money(i.final_price)}</p>
            </div>
            <div class="qty-stepper">
              <button type="button" data-cart-change="${i.key}" data-delta="-1" aria-label="Decrease quantity">−</button>
              <span>${i.quantity}</span>
              <button type="button" data-cart-change="${i.key}" data-delta="1" aria-label="Increase quantity">+</button>
            </div>
          </div>`).join('');
      }
    }

    const sub = document.querySelector('.cart-subtotal-value');
    if (sub) sub.textContent = money(cart.total_price);

    const shipText = document.querySelector('.free-shipping-text');
    const shipFill = document.querySelector('.progress-fill');
    if (shipText && shipFill) {
      if (cart.total_price >= FREE_SHIP_CENTS) {
        shipText.textContent = "You've got free shipping!";
        shipFill.style.width = '100%';
      } else {
        const remaining = FREE_SHIP_CENTS - cart.total_price;
        shipText.textContent = `You're ${money(remaining)} away from free shipping`;
        shipFill.style.width = `${(cart.total_price / FREE_SHIP_CENTS) * 100}%`;
      }
    }
  }

  function toggleCart(open) {
    const drawer = document.getElementById('cart-drawer');
    const overlay = document.getElementById('cart-overlay');
    if (!drawer) return;
    const isOpen = drawer.classList.contains('open');
    const shouldOpen = open === undefined ? !isOpen : open;
    drawer.classList.toggle('open', shouldOpen);
    overlay?.classList.toggle('open', shouldOpen);
    drawer.setAttribute('aria-expanded', String(shouldOpen));
    if (shouldOpen) fetchCart().then(renderCart);
  }

  function initHeaderScroll() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    const update = () => header.classList.toggle('scrolled', window.scrollY > 50);
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initMobileMenu() {
    const toggle = document.querySelector('.mobile-menu-toggle');
    const overlay = document.querySelector('.mobile-nav-overlay');
    if (!toggle || !overlay) return;
    toggle.addEventListener('click', () => {
      overlay.classList.toggle('open');
      toggle.setAttribute('aria-expanded', String(overlay.classList.contains('open')));
    });
  }

  function initFadeIn() {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => e.isIntersecting && e.target.classList.add('visible'));
    }, { threshold: 0.1 });
    document.querySelectorAll('.fade-in-up').forEach((el) => obs.observe(el));
  }

  function initStatCounters() {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.target.classList.contains('counted')) return;
        entry.target.classList.add('counted');
        const target = parseInt(entry.target.getAttribute('data-target') || '0', 10);
        const duration = 2000;
        const start = performance.now();
        const step = (t) => {
          const p = Math.min((t - start) / duration, 1);
          const eased = 1 - (1 - p) * (1 - p);
          entry.target.textContent = Math.floor(eased * target);
          if (p < 1) requestAnimationFrame(step);
          else entry.target.textContent = target;
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.stat-number').forEach((el) => obs.observe(el));
  }

  function initTilt() {
    document.querySelectorAll('.flavour-card').forEach((card) => {
      card.addEventListener('mousemove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        const inner = card.querySelector('.product-card-img, .can-shape');
        if (inner) inner.style.transform = `perspective(1000px) rotateY(${x * 15}deg) rotateX(${-y * 15}deg) scale(1.05)`;
      });
      card.addEventListener('mouseleave', () => {
        const inner = card.querySelector('.product-card-img, .can-shape');
        if (inner) inner.style.transform = '';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeaderScroll();
    initMobileMenu();
    initFadeIn();
    initStatCounters();
    initTilt();

    document.querySelectorAll('.cart-toggle, .cart-close, .cart-drawer-overlay').forEach((el) => {
      el.addEventListener('click', (e) => { e.preventDefault(); toggleCart(); });
    });

    document.body.addEventListener('click', async (e) => {
      const add = e.target.closest('.quick-add, .add-to-cart-btn');
      if (add && !add.disabled) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = add.getAttribute('data-variant-id');
        if (!variantId) { console.warn('quick-add missing data-variant-id'); return; }
        let qty = 1;
        const qtyEl = document.getElementById('product-qty');
        if (qtyEl) qty = parseInt(qtyEl.value, 10) || 1;
        add.disabled = true;
        try {
          await addToCart(variantId, qty);
          const cart = await fetchCart();
          renderCart(cart);
          toggleCart(true);
        } catch (err) {
          console.warn('add-to-cart failed', err);
        } finally {
          add.disabled = false;
        }
        return;
      }

      const change = e.target.closest('[data-cart-change]');
      if (change) {
        e.preventDefault();
        const key = change.getAttribute('data-cart-change');
        const delta = parseInt(change.getAttribute('data-delta'), 10);
        const line = change.closest('.cart-item');
        const currentQty = parseInt(line?.querySelector('.qty-stepper span')?.textContent || '0', 10);
        const cart = await changeQty(key, Math.max(0, currentQty + delta));
        renderCart(cart);
      }
    });

    const qEl = document.getElementById('product-qty');
    document.getElementById('qty-dec')?.addEventListener('click', () => {
      const v = parseInt(qEl.value, 10); if (v > 1) qEl.value = v - 1;
    });
    document.getElementById('qty-inc')?.addEventListener('click', () => {
      qEl.value = parseInt(qEl.value, 10) + 1;
    });

    const contact = document.getElementById('contact-form');
    if (contact) contact.addEventListener('submit', (e) => {
      e.preventDefault();
      document.querySelector('.form-success')?.classList.add('visible');
      contact.reset();
    });
    const trade = document.getElementById('trade-enquiry-form');
    const tradeSuccess = document.getElementById('trade-form-success');
    if (trade) trade.addEventListener('submit', (e) => {
      e.preventDefault();
      trade.style.display = 'none';
      if (tradeSuccess) tradeSuccess.style.display = 'block';
    });

    fetchCart().then(renderCart);
  });
})();
